import { UploadFileEntry } from './UploadFileEntry';
import { UploadFileEntriesType } from './UploadFileTypes';

const UploadFileEntries = ({
	files,
	fileErrors,
	selectedFilesHeader,
	removeFileCallback,
	maxFiles,
	maxSize,
	extensionDisplayValue,
}: UploadFileEntriesType) => {
	return (
		<div className={`upload-file-info`}>
			{files.map((file, index) => (
				<UploadFileEntry
					key={`fileUploadSingle${file.size}${file.name}${index}`}
					file={file}
					valid={!fileErrors.fileNames.includes(file.name) && file.size < maxSize}
					fileType={extensionDisplayValue}
					removeCallback={() => removeFileCallback(index)}
				/>
			))}
		</div>
	);
};

export { UploadFileEntries };
